export const triggerRemoteDownload = (url, filename) => {
  if (!url) throw new Error('A download URL is required.');

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename || '';
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};
